
import Game from '../engine/Game';
import Room from '../engine/Room';
import { Puzzle } from '../engine/Puzzle';
import Button from '../engine/Button';
import {
    ActionRoom, ActionMsg, ActionMarkUsed, ActionMove, ActionPoints, ActionLink, ActionEndGame
} from '../engine/Action';
import Image from '../engine/Image';
import Hint from '@/engine/Hint';

Game.registerDefault('sanjuan', () => {

    let button, imagen, puzzle;

    const game = new Game();

    //
    // Rooms, to have all the references
    //

    const room00 = new Room('Entrada', 'open');
    const room01 = new Room('Clase de Vega', 'open');
    const room02 = new Room('Atención a la diversidad');
    const room03 = new Room('Clase de Ángel');
    const room04 = new Room('Clase de Goretti');
    const room05 = new Room('Clase de Félix');
    const room06 = new Room('Clase de Beatriz Martín');
    const room07 = new Room('Clase de Beatriz Domingo');
    const room08 = new Room('Clase de Laura');
    const room09 = new Room('Clase de Ana Maria');
    const room21 = new Room('Puerta del patio');
    const room22 = new Room('Patio');
    const room31 = new Room('Fin');

    game.add(room00);
    game.add(room01);
    game.add(room02);
    game.add(room03);
    game.add(room04);
    game.add(room05);
    game.add(room06);
    game.add(room07);
    game.add(room08);
    game.add(room09);
    game.add(room21);
    game.add(room22);
    game.add(room31);

    //
    // Room 00
    //

    imagen = new Image('sanjuan/room00_cole.jpg');
    room00.add(imagen);

    room00.add(`
        Estamos en Junio de 2020, somos un grupo de alumnos de 4º E.S.O
        del colegio San Juan de la Cruz.
        Este es nuestro último curso en este colegio,
        y esperamos ansiosos nuestra graduación.
        Sin embargo, un virus, llamado COVID19, ha truncado nuestras expectativas
        y se han anulado nuestras clases.
    `);

    room00.add(`
        En la tele escuchamos a diario, que no se podrán hacer grandes reuniones,
        ¿Y nuestra graduación? Pues para guardar la distancia mínima y respetar el aforo máximo,
        cuando llegue la tan ansiada “nueva normalidad”,
        solo los que demostremos que hemos realizado todo nuestro paso por este estupendo centro con éxito,
        conseguiremos entradas para tan esperado acontecimiento.
        Para poder demostrarlo tendremos que conseguir nuestro diploma acreditativo,
        que nos han escondido por el colegio.
    `);

    room00.add(`
        Comenzamos...   
    `);


    imagen = new Image('sanjuan/room00_anuario.png');
    room00.add(imagen);


    room00.add(`
        No tenemos ninguna pista para empezar nuestra andadura,
        tan solo contamos con un antiguo anuario, abierto por una de las páginas.
        En esa página podemos ver como aparecen sonrientes alumnos de 2º E.I.,
        tras pensar un rato, nos dirigimos a clase de VEGA, ya que ella es la tutora de ese curso.
    `);

    button = new Button('Entrar en clase de Vega');
    button.add(new ActionMove(room01));
    room00.add(button);


    /*
    button = new Button('Debug: abrir todas las salas');
    button.add(new ActionRoom(room01, 'open'));
    button.add(new ActionRoom(room02, 'open'));
    button.add(new ActionRoom(room03, 'open'));
    button.add(new ActionRoom(room04, 'open'));
    button.add(new ActionRoom(room05, 'open'));
    button.add(new ActionRoom(room06, 'open'));
    button.add(new ActionRoom(room07, 'open'));
    button.add(new ActionRoom(room08, 'open'));
    button.add(new ActionRoom(room09, 'open'));
    button.add(new ActionRoom(room21, 'open'));
    button.add(new ActionRoom(room22, 'open'));
    room00.add(button);
    */




    //
    // Room 01
    //

    imagen = new Image('sanjuan/room01.jpg');
    room01.add(imagen);

    room01.add(`
        Encima de su mesa observamos la imagen de un Virgen María,
        está claro que en el cole estaban preparando actividades
        para este mes de Mayo
        y a nuestro recuerdo viene la cantidad de ofrendas florales
        que hemos hecho nosotros a la Virgen a lo largo de nuestra etapa en el Colegio.
        Ya que la Pastoral ha estado siempre muy presente
        en nuestro desarrollo como personas a lo largo de estos años.
    `);

    room01.add(`
        Junto a la mesa, se encuentra una caja cerrada, con una combinación numérica.
        En el suelo encontramos un libro sobre trangram,
        parece contener las instrucciones para descifrar la combinación.
    `);

    imagen = new Image('sanjuan/room01_bookB.png', 'sanjuan/room01_bookA.png');
    room01.add(imagen);

    puzzle = new Puzzle('keypad', {
        code:'4132756',
        layout:[['1','2','3'],['4','5','6'],['7','8','9'],['','0','clear']],

    });

    puzzle.add(new Hint(`
        La clave es el número de las piezas del tangram según están puestas
        en a figura empezando de arriba a abajo y de izquierda a derecha,
        en las piezas que son iguales con distintos número,
        se pone primero el número más pequeño.
    `));

    puzzle.add(new Hint(`
        La solución es 4132756
    `));


    room01.add(puzzle);

    puzzle.add(new ActionMsg(`
        Enhorabuena, has demostrado que eres hábil, y a pesar de la añoranza
        que te ha causado volver a esas clases en las que aprendiste a leer,
        has sido capaz de abrir esta caja.
        Dentro de la caja se encuentra una llave, tras intentar abrir en todas
        las puertas de esa planta,
        te das cuenta que la única clase que se puede abrir,
        es la de atención a la diversidad.
    `));

    puzzle.add(new ActionRoom(room02, 'open'));
    puzzle.add(new ActionPoints(10));
    puzzle.add(new ActionMove(room02));

    //
    // Room 02
    //

    imagen = new Image('sanjuan/room02.jpg');
    room02.add(imagen);


    room02.add(`
        Acabáis de entrar en el aula de atención a la diversidad,
        aquí es donde Adela, Mª Jesús y Esperanza, con mucho mimo,
        atienden a todos vuestros compañeros que lo necesitan,
        porque en este cole, ningún alumno se queda atrás.

        En la clase, hay un enorme armario, pero está cerrado,
        para desbloquearlo necesitamos acertar con una palabra.
        Nos fijamos que la pizarra contiene unos signos y una frase
        medio borrada, ¿Qué querrá decir?
    `);

    imagen = new Image('sanjuan/room02_blackboard.png');
    room02.add(imagen);


    
    room02.add(`
        Rebuscando un poco, vemos que encima de una estantería,
        las profes tienen una enorme cartulina enmarcada
        con signos muy parecidos a los anteriores.`
    );

    imagen = new Image('sanjuan/room02_braile.png');
    room02.add(imagen);



    puzzle = new Puzzle('text', {
        code:'inclusion',
    });
    room02.add(puzzle);

    puzzle.add(new ActionMsg(`
        Muy bien chicos, se nota que sabéis poneros en el lugar de vuestros
        compañeros con necesidades especiales, dentro del armario,
        hay una gran llave,
        la probáis en todas las aulas del primer piso del cole,
        y comprobáis que la clase que abre es la de 4º E.P.
    `));

    puzzle.add(new ActionRoom(room03, 'open'));
    puzzle.add(new ActionPoints(10));
    puzzle.add(new ActionMove(room03));

    puzzle.add(new Hint(`
        La clave es la palabra que está tachada,
        usa el código Morse para saber de que palabra se trata.
    `));

    puzzle.add(new Hint(`
        La solución es INCLUSION
    `));



    

    /*
    puzzle = new Puzzle('keypad', {
        code:'inclusion',
        layout:[
            [...'abcdefg'.split('')],
            [...'hijklmn'.split('')],
            [...'opqrstu'.split('')],
            [...'vwxyz'.split(''),'','clear'],
        ],
        font:"braille"
    });
    room02.add(puzzle);
    */


    //
    // Room 03
    //

    imagen = new Image('sanjuan/room03.jpg');
    room03.add(imagen);


    room03.add(`
        Entras en la clase y descubres que Ángel,
        el profesor de Música ha dejado encendido su pc
        que te pide una contraseña.
        ¿Qué pretenderá que pongamos? 
        Te fijas en una de las paredes,
        y te llama la atención un cartel que tiene colgado.
    `);


    imagen = new Image('sanjuan/room03_signos.png');
    room03.add(imagen);


    room03.add('También observas, que en la pizarra, hay algo, escrito, se trata del siguiente pentagrama');

    imagen = new Image('sanjuan/room03_notas.png');
    room03.add(imagen);

    room03.add('Un papel sobre la mesa parece contener una pista importante');


    imagen = new Image('sanjuan/room03_pista.png');
    room03.add(imagen);

    puzzle = new Puzzle('laptop', {
        code:'relamido',
    });


    puzzle.add(new ActionRoom(room04, 'open'));
    puzzle.add(new ActionPoints(10));
    puzzle.add(new ActionMove(room04));

    puzzle.add(new ActionMsg(`
        Estupendo está claro que la Música es lo vuestro, y Ángel y Basulto
        han inculcado en vosotros el amor hacia esta materia,
        seguro que muchos de vosotros hasta habéis formado parte de la Escolanía,
        pero no os relajeis, aún quedan muchas pruebas que pasar,
        ahora toca cambiar de planta, pero antes de salir,
        mirais con mucho cariño, las clases de Chus, Elsa y Dani,
        que tan buenos ratos os han hecho pasar.
        Al subir la rampa, unas voces llaman vuestra atención,
        es Montse que está en secretaria hablando con Pablo,
        vosotros seguís vuestro camino y entráis en Clase de Goretti.
    `));

    puzzle.add(new Hint(`
        Primero debes descifrar la frase sustituyendo los símbolos
        por las notas musicales a los que hacen referencia.
        Cuando lo tengas, la clave es,
        la palabra que forman las notas escritas en el pentagrama.
    `));

    puzzle.add(new Hint(`
        La solución es RELAMIDO
    `));



    room03.add(puzzle);
    

   
    //
    // Room 04
    //

    imagen = new Image('sanjuan/room04.jpg');
    room04.add(imagen);


    room04.add(`
        Ya estáis en la segunda planta, os encontráis en la clase de Goretti,
        a pesar de todos los ordenadores que hay en este aula,
        lo que más os llama la atención, es un póster que está colgado en la puerta.
        En él hay varias perspectivas,
        que tantas veces habéis practicado en clase de Educación Plástica y Visual.
    `);

    imagen = new Image('sanjuan/room04_perspectiva.png');
    room04.add(imagen);

    room04.add(`
        Para poder avanzar tenéis que resolver el siguiente panel.
    `);

    puzzle = new Puzzle('keypad', {
        code:'CDFHIJ',
        layout:[
            [...'ABCD'.split(''),''],
            [...'EFGH'.split(''),''],
            [...'IJKL'.split(''),'clear'],
        ],
    });
    

    puzzle.add(new ActionRoom(room05, 'open'));
    puzzle.add(new ActionPoints(10));
    puzzle.add(new ActionMove(room05));

    puzzle.add(new ActionMsg(`
        ¡Sois unos cracks!,
        habéis conseguido demostrar que las destrezas plásticas
        las tenéis superadas, Goretti y Patri se han encargado de ello,
        pero ¿Y las lingüísticas?
        Tenéis que dirigiros a clase de Félix para poder demostrarlo.
    `));

    room04.add(puzzle);


    puzzle.add(new Hint(`
        La solución son las letras de las vistas que corresponden al cubo.
    `));
    puzzle.add(new Hint(`
        La solución es CDFHIJ
    `));



    
    //
    // Room 05
    //

    imagen = new Image('sanjuan/room05.jpg');
    room05.add(imagen);


    room05.add(`
        Ha llegado la hora de demostrar vuestra cultura literaria,
        que con tanto mimo se han ocupado Ana Mª, Félix y Fran de inculcaros.
        Sabemos que la comprensión lectora la tenéis más que superada,
        pues así lo habéis demostrado en las pruebas de lectura eficaz,
        que desde todas las áreas os hemos ido haciendo a lo largo de los trimestres.
        También sabemos que muchos de vuestros padres han formado parte del
        “Club de lectura de padres y madres”,
        seguro que con todas estas armas, sois capaces de resolver
        el siguiente enigma.
    `);

    imagen = new Image('sanjuan/room05_tabla.png');
    room05.add(imagen);

    imagen = new Image('sanjuan/room05_notebook.png', 'sanjuan/room05_notebook.png');
    room05.add(imagen);

    room05.add(`
        Suma el año de nacimiento de los andaluces y
        réstale el año de nacimiento de los otros dos autores
    `);







    puzzle = new Puzzle('text', {
        code:'0076',
    });
    room05.add(puzzle);

    puzzle.add(new ActionMsg(`
        Enhorabuena,
        no sabéis lo felices que nos hace saber que además del graduado,
        habéis conseguido convertiros en unas personas cultas
        y amantes de la lectura.
        La caja contenía una llave con el número 200,
        que coincide con el aula de Beatriz M.
    `));

    puzzle.add(new ActionRoom(room06, 'open'));
    puzzle.add(new ActionPoints(10));
    puzzle.add(new ActionMove(room06));

    puzzle.add(new Hint(`
        Tienes que rellenar la tabla y
        conseguir el año de nacimiento de los cuatro autores.
        Cuando lo tengas tienes sumar la edad de
        Federico García Lorca y Luis Cernuda
        y restarle el año de nacimiento de José de Espronceda y Blas de Otero. 
    `));

    puzzle.add(new Hint(`
        La solución es 0076
    `));

    
        
    //
    // Room 06
    //

    imagen = new Image('sanjuan/room06.jpg');
    room06.add(imagen);


    room06.add(`
        Entráis en la clase de Beatriz Martín, profesora de Economía,
        veis que encima de la mesa, ha dejado olvidadas 4 monedas,
        y os llama la atención que todas ellas están por el reverso,
        y algunas muestran imágenes poco conocidas para vosotros.
        ¿De qué países serán?
    `);


    imagen = new Image('sanjuan/room06_monedas.png');
    room06.add(imagen);


    room06.add(`
        Observáis que el ordenador lo ha dejado encendido
        y tiene abierta la página del BCE (Banco Central Europeo)
    `);

    button = new Button('Caras nacionales BCE');
    button.add(new ActionLink('https://www.ecb.europa.eu/euro/coins/1euro/html/index.es.html'));
    room06.add(button);


    room06.add(`
       Un cartel muestra el año de entrada de todos los países a la UE.
    `);



    imagen = new Image('sanjuan/room06_paises.png');
    room06.add(imagen);

    room06.add(`
       El criptex sobre la mesa parece tener algo en su interior
    `);


    puzzle = new Puzzle('cryptex', {
        code:'FIGE',
    });
    room06.add(puzzle);

    puzzle.add(new ActionMsg(`
        Muy bien chicos, habéis sido capaces de resolver este enigma que no era nada fácil.
        Ahora debéis poner a prueba vuestra competencia matemática,
        para ello os dirigis a la clase de la otra tutora de 4º E.S.O, Bea Domingo.
    `));

    puzzle.add(new ActionRoom(room07, 'open'));
    puzzle.add(new ActionPoints(10));
    puzzle.add(new ActionMove(room07));

    puzzle.add(new Hint(`
        La Solución son las iniciales de los países que aparecen en las monedas,
        ordenados por la fecha en la que se incorporaron a la UE.
    `));

    puzzle.add(new Hint(`
        La solución es FIGE
    `));



    //
    // Room 07
    //

    imagen = new Image('sanjuan/room07.jpg');
    room07.add(imagen);


    room07.add(`
        Entrais en la clase de Bea D, sin duda la profesora que más
        sabe de Matemáticas de todo el centro, de la pizarra cuelga un mural,
        lleno de emojis, que parece esconder la clave para poder seguir avanzando.
    `);

    imagen = new Image('sanjuan/room07_emoji.png');
    room07.add(imagen);


    puzzle = new Puzzle('text', {
        code:'27',
    });
    room07.add(puzzle);


    puzzle.add(new ActionMsg(`
        Buen trabajo chicos, cada vez estáis más cerca de conseguirlo,
        ahora debéis subir al piso de arriba y seguir demostrando todo lo aprendido.
        Antes de subir, os despedís de las clases de Guillermo, Sergio y Leti,
        en las que tanto habéis aprendido a lo largo de todos estos años.
        Subis a la primera última planta, intentáis abrir la clase de Javier,
        pero está cerrada, pero la de enfrente, sí que está abierta.
    `));

    puzzle.add(new ActionRoom(room08, 'open'));
    puzzle.add(new ActionPoints(10));
    puzzle.add(new ActionMove(room08));

    puzzle.add(new Hint(`
        Tienes que resolver un sistema de 4 ecuaciones y 4 incógnitas,
        y cuando tengas la soluciones de las incógnitas hacer la suma.
    `));

    puzzle.add(new Hint(`
        La solución es 27
    `));




    //
    // Room 08
    //

    imagen = new Image('sanjuan/room08.jpg');
    room08.add(imagen);


    room08.add(`
        Entráis en clase de Laura, profe de Tecnología,
        veis que encima de la mesa tiene una caja electrónica,
        llena de cables, para poder abrirla,
        tendréis que cortarlos adecuadamente.
        ¿Pero cómo sabremos cómo debemos hacerlo?
        Afortunadamente, revolviendo en las estanterías encontráis
        un manual de desactivación.
    `);

    imagen = new Image('sanjuan/room08_clipboard.png', 'sanjuan/room08_clipboard_mini.png');
    room08.add(imagen);


    puzzle = new Puzzle('wirecut', {
        code:'302', // aranja, azul y verde
        layout:{
            connectorsA: [
                'A', 'B', 'C',null,'D'
            ],
            connectorsB: [
                'O', 'P', 'Q','R','S'
            ],
            wires: [
                {ini:'A', end:'R', color:'#4254f5'},
                {ini:'B', end:'O', color:'#f54242'},
                {ini:'C', end:'S', color:'#42f55a'},
                {ini:'D', end:'P', color:'#EF7F1A'},
            ],
            seed: 2,
        },
        reseteable: true,
        model: 'Model ID: BKR2-2020'
    });
    room08.add(puzzle);


    puzzle.add(new ActionMsg(`
        ¡GENIAL CHICOS! Ya casi no queda nada, pero no hay tiempo que perder,
        necesitáis llegar los primeros para poder ser de los pocos que
        puedan acudir al acto de graduación. 
    `));

    puzzle.add(new ActionRoom(room09, 'open'));
    puzzle.add(new ActionPoints(10));
    puzzle.add(new ActionMove(room09));

    puzzle.add(new Hint(`
        Tienes que cortar los cables siguiendo el orden de colores que marcan las instrucciones.
    `));

    puzzle.add(new Hint(`
        La solución es Naranja, Azul y Verde
    `));






    //
    // Room 09
    //

    imagen = new Image('sanjuan/room09.jpg');
    room09.add(imagen);


    room09.add(`
        Habéis llegado a la última clase, la de Ana Mª,
        tendréis que demostrar que en todos estos años habéis 
        aprendido a defenderos en otros idiomas de la mano de José Ángel,
        Ana Mª y Félix.

        Además muchos de vosotros habéis hecho el itinerario bilingüe
        y habéis conseguido un nivel muy alto de inglés.
    `);



    room09.add(`
        Multiple named pictures and a notebook are the next
        challenge you must face.
        You have to identify the person using the notebook
        description. 
    `);


    imagen = new Image('sanjuan/room09_whois.jpg');
    room09.add(imagen);


    
/*
    room09.add(`
    WHO IS?
    The person is not bald.
    The person is young.
    The person doesn't wear glasses.
    The person  doesn't have brown hair.
    The person doesn't have a hat.
     The person doesn't have a moustache.
     The person doesn't have brown hair.
    The person is a girl.
    The person is got pigtails.
`   );
*/

    imagen = new Image('sanjuan/room09_notebook.png','sanjuan/room09_notebook.png');
    room09.add(imagen);



    puzzle = new Puzzle('text', {
        code:'anita',
    });
    room09.add(puzzle);



    puzzle.add(new ActionMsg(`
        Enhorabuena habéis logrado superar todas las pruebas,
        ahora deberéis ir corriendo hacía el patio,
        la graduación está a punto de empezar,
        y aún quedan sitios libres para vosotros. 
        Bajaís corriendo por las rampas,
        y recordáis con cariño la cantidad de veces que vuestros profesores
        os han reñido por bajar así, en el fondo sabéis
        que les vais a echar de menos.
    `));

    puzzle.add(new ActionRoom(room21, 'open'));
    puzzle.add(new ActionPoints(10));
    puzzle.add(new ActionMove(room21));

    puzzle.add(new Hint(`
        La clave es el nombre de la única persona
        que cumple todas las características de las frases
    `));
    puzzle.add(new Hint(`
        La solución es Anita
    `));



    

    //
    // Room 21
    //

    imagen = new Image('sanjuan/room21.jpg');
    room21.add(imagen);


    room21.add(`
        Os encontráis justo en la puerta del patio,
        queréis salir pero la puerta está bloqueada,
        y os pide una clave para poder abrirla,
        os llama la atención un sobre que se encuentra en la puerta,
        lo abrís y leéis detenidamente,
        parece que alguien tiene algo que deciros.
    `);

    imagen = new Image('sanjuan/room21_cartabea.png', 'sanjuan/room21_cartabea.png');
    room21.add(imagen);



    puzzle = new Puzzle('text', {
        code:'RESILIENCIA',
    });
    room21.add(puzzle);



    puzzle.add(new ActionMsg(`
        Ahora sí habéis llegado al final,
        aquí tenéis vuestro diploma
        y nuestro agradecimiento por haber formado parte de este colegio.
    `));

    puzzle.add(new ActionRoom(room22, 'open'));
    puzzle.add(new ActionPoints(10));
    puzzle.add(new ActionMove(room22));
    puzzle.add(new ActionEndGame());

    puzzle.add(new Hint(`
        Fíjate en las letras en negrita.
    `));

    puzzle.add(new Hint(`
        La solución es RESILIENCIA
    `));


    


    //
    // Room 22
    //
    room22.add(`
        ¡Enhorabuena! Toda la comunidad que forma este centro está muy
        orgullosos de vosotros. Antes de iros, el director títular
        tiene unas palabras para vosotros.
    `);

    imagen = new Image('sanjuan/room22_carta.png', 'sanjuan/room22_sobre.png');
    room22.add(imagen);


    button = new Button('¿Fin?');
    button.add(new ActionMove(room31));
    button.add(new ActionRoom(room31, 'open'));
    room22.add(button);




    //
    // Room 31
    //

    room31.add(`
        Este escape ha sido creado por la profesora Beatriz Martín Tomás 
        y el informático Javier Fresno Bausela
        durante la pandemia del Covid-19
        para despedir a los alumnos de 4º de E.S.O
        y conmemorar el 50 aniversario del colegio 1970-2020.
    `);

    imagen = new Image('sanjuan/beajavi.png');
    room31.add(imagen);

    room31.add(`
        Si has conseguido llegar hasta aquí comparte
        una captura de pantalla en Twitter,
        Facebook, Instagram... 
        con tu puntuación con el siguiente hashtag 
        #escapesjcmc desde las RRSS del colegio
        compartiremos a los que consigan mayor puntuación.
    `);








    return game;

});